/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, runOn, markType } from "igniteui-react-core";
import { ICellRenderingEngine_$type } from "./ICellRenderingEngine";
import { CurrentRendererSettings } from "./CurrentRendererSettings";
import { RenderingContext } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { CanvasViewRenderer } from "igniteui-react-core";
import { intDivide } from "igniteui-react-core";
/**
 * @hidden
 */
var DataGridCellLayoutPanel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataGridCellLayoutPanel, _super);
    function DataGridCellLayoutPanel(a, b, c) {
        var _this = _super.call(this) || this;
        _this.e = null;
        _this.k = false;
        _this.q = null;
        _this._element = null;
        _this.f = null;
        _this.i = false;
        _this.m = false;
        _this.g = null;
        _this.l = false;
        _this._requestAnimationFrame = null;
        _this.s = 0;
        _this.o = -1;
        _this.n = -1;
        _this.j = false;
        _this.p = 0;
        _this.c = null;
        _this.a = null;
        _this.d = null;
        _this.b = null;
        _this.p = c;
        _this.q = a;
        _this.requestAnimationFrame = _this.q.getRequestAnimationFrame();
        _this.element = _this.q.createElement("div");
        _this.element.setRawStyleProperty("position", "relative");
        _this.element.setRawStyleProperty("box-sizing", "border-box");
        _this.refresh(_this.e, false);
        _this.f = b;
        _this.i = false;
        return _this;
    }
    Object.defineProperty(DataGridCellLayoutPanel.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (a) {
            this._element = a;
        },
        enumerable: true,
        configurable: true
    });
    DataGridCellLayoutPanel.prototype.refresh = function (a, b) {
        this.e = a;
        this.aj(b);
    };
    DataGridCellLayoutPanel.prototype.viewportChanged = function () {
        this.aj(true);
    };
    DataGridCellLayoutPanel.prototype.invalidateVisibility = function (a) {
        this.g = a;
        this.m = true;
    };
    Object.defineProperty(DataGridCellLayoutPanel.prototype, "initialRefreshFinished", {
        get: function () {
            return this.i;
        },
        enumerable: true,
        configurable: true
    });
    DataGridCellLayoutPanel.prototype.ab = function (a, b, c, d) {
        this.aj(true);
    };
    DataGridCellLayoutPanel.prototype.ai = function (a) {
        var b = this.f.b(this.q, a);
        if (b.isCanvasBased) {
            var c = b.nativeCell.ac = false;
        }
        else {
            var d = b.nativeCell.z;
            d.setRawStyleProperty("top", "-1000px");
            d.setRawStyleProperty("left", "-1000px");
            if (a.k.d != 0) {
                d.setRawStyleProperty("clip", "auto");
            }
        }
    };
    DataGridCellLayoutPanel.prototype.aj = function (a) {
        if (a) {
            this.k = true;
            this.u();
            return;
        }
        if (this.l) {
            return;
        }
        if (this.k) {
            return;
        }
        this.k = true;
        this.x(runOn(this, this.u));
    };
    Object.defineProperty(DataGridCellLayoutPanel.prototype, "requestAnimationFrame", {
        get: function () {
            return this._requestAnimationFrame;
        },
        set: function (a) {
            this._requestAnimationFrame = a;
        },
        enumerable: true,
        configurable: true
    });
    DataGridCellLayoutPanel.prototype.x = function (a) {
        this.requestAnimationFrame(a);
    };
    DataGridCellLayoutPanel.prototype.u = function () {
        if (!this.k) {
            return;
        }
        this.k = false;
        if (this.m) {
            this.m = false;
            this.g();
        }
        if (this.e == null) {
            return;
        }
        if (Rect.l_op_Equality(this.e.actualVisibleRegion, null) || this.e.actualVisibleRegion.isEmpty) {
            return;
        }
        this.i = true;
        if (this.o != this.e.absoluteWidth) {
            this.element.setRawStyleProperty("width", this.e.absoluteWidth + "px");
        }
        if (this.n != this.e.absoluteHeight) {
            this.element.setRawStyleProperty("height", this.e.absoluteHeight + "px");
        }
        this.o = this.e.absoluteWidth;
        this.n = this.e.absoluteHeight;
        var a = this.e.actualVisibleRegion.top;
        var b = this.e.actualVisibleRegion.left;
        var c = this.e.bu;
        var d = c.count;
        var e = this.e.bh;
        var f = this.e.bh.o;
        var g = f.count;
        var h = this.e.bh.p;
        for (var i = 0; i < g; i++) {
            if (h._inner[i]) {
                continue;
            }
            var j = e.item(f._inner[i]);
            for (var k = 0; k < j.count; k++) {
                var l = j._inner[k];
                this.ai(l);
            }
        }
        e.u();
        var m = false;
        var n = this.s;
        var o = true;
        var p = false;
        for (var q = 0; q < d; q++) {
            var r = c._inner[q].q;
            var s = c._inner[q].q.count;
            var t = c._inner[q].p;
            for (var u = 0; u < s; u++) {
                if (t._inner[u]) {
                    continue;
                }
                var v = r._inner[u];
                var w = this.f.b(this.q, v);
                if (!w.isCanvasBased) {
                    o = false;
                }
                else {
                    p = true;
                }
                if (v.a0) {
                    m = true;
                }
                if (v.t == 1 && v.gc != n) {
                    m = true;
                }
            }
        }
        if (p) {
            this.w();
        }
        if (m) {
            if (this.s == 0x7FFFFFFFFFFFFFFF - 1) {
                this.s = 0;
            }
            else {
                this.s++;
            }
            n = this.s;
        }
        var x = 0;
        var y = new CurrentRendererSettings();
        var z = this.p;
        this.l = true;
        for (var aa = 0; aa < d; aa++) {
            var ab = c._inner[aa].q;
            var ac = c._inner[aa].q.count;
            var ad = c._inner[aa].p;
            for (var ae = 0; ae < ac; ae++) {
                if (ad._inner[ae]) {
                    continue;
                }
                var af = ab._inner[ae];
                var ag = this.f.b(this.q, af);
                if (ag.isCanvasBased) {
                    var ah = y.a;
                    this.an(y, aa, af, this.e, x, m, o);
                    if (y.a != ah && m) {
                        x++;
                    }
                }
                var ai = ag.isCanvasBased;
                var aj = null;
                if (!ai) {
                    aj = ag.nativeCell.z;
                    if (af.t == 0) {
                        this.element.append(aj);
                    }
                }
                if (af.t == 1) {
                    if (ai) {
                        var ak = af.r.nativeCell;
                        ak.ac = true;
                    }
                }
                af.t = 2;
                var al = (af.fv + intDivide(af.f8, 2));
                var am = (af.fx + intDivide(af.ev, 2));
                var an = (al - b) / this.e.actualVisibleRegion.width;
                var ao = (am - a) / this.e.actualVisibleRegion.height;
                if (af.a2) {
                    if (!ai) {
                        aj.setRawPosition(af.b7, af.b8);
                    }
                }
                if (!ai) {
                    if (af.k.d != 0) {
                        if (this.e.bk) {
                            aj.setRawStyleProperty("clip", this.t(af.k.d, af.b7, af.b8));
                        }
                        else {
                            aj.setRawStyleProperty("clip", "auto");
                        }
                    }
                    else {
                        aj.setRawStyleProperty("clip", "auto");
                    }
                }
                af.i7();
                if (ai) {
                    var ap = af.r.nativeCell;
                    ap.ch(z);
                }
                af.r.modelUpdated(af);
                if (ai && y.b) {
                    var aq = y.a;
                    aq.z();
                    if (af.k.d != 0 && this.e.bk) {
                        aq.ae(this.ao(af.k.d));
                    }
                    var ar = af.r.nativeCell;
                    ar.bz(aq, y.c, y.d, af.b7, af.b8, z);
                    aq.y();
                }
                af.i0();
                if (m) {
                    af.gc = n;
                    if (!ai) {
                        aj.setRawStyleProperty("z-index", x.toString());
                    }
                    x++;
                }
            }
        }
        this.l = false;
        if (y.a != null && this.p != 1) {
            y.a.y();
        }
    };
    DataGridCellLayoutPanel.prototype.w = function () {
        if (!this.j) {
            this.j = true;
            var a = this.q.rootWrapper;
            var b = (window.navigator.msPointerEnabled && MSGesture !== undefined);
            var c = (window.PointerEvent || window.navigator.pointerEnabled);
            var d = (window.TouchEvent);
            if ((b || c)) {
                a.listen("pointerdown", runOn(this, this.af));
                a.listen("pointerup", runOn(this, this.ah));
                a.listen("pointermove", runOn(this, this.ag));
            }
            else {
                a.listen("mousedown", runOn(this, this.y));
                a.listen("mouseup", runOn(this, this.aa));
                a.listen("mousemove", runOn(this, this.z));
                a.listen("touchstart", runOn(this, this.ak));
                a.listen("touchend", runOn(this, this.am));
                a.listen("touchmove", runOn(this, this.al));
            }
            a.listen("dblclick", runOn(this, this.v));
        }
    };
    DataGridCellLayoutPanel.prototype.y = function (a) {
        this.ae(a, false);
    };
    DataGridCellLayoutPanel.prototype.aa = function (a) {
        this.ac(a, false);
    };
    DataGridCellLayoutPanel.prototype.z = function (a) {
        this.ad(a, false);
    };
    DataGridCellLayoutPanel.prototype.v = function (a) {
        if (this.e == null) {
            return;
        }
        var b = this.q.rootWrapper.getOffset();
        var c = this.e.e(a.pageX - b.left, a.pageY - b.top);
        if (c == null) {
            return;
        }
        if (c.r != null) {
            if (c.r.isCanvasBased && c.r.nativeCell != null) {
                c.r.nativeCell.onDoubleClick(a);
            }
        }
    };
    DataGridCellLayoutPanel.prototype.af = function (e_) {
        var a = (e_.originalEvent.pointerType);
        if (a == "touch") {
            this.ak(e_);
        }
        else {
            this.y(e_);
        }
    };
    DataGridCellLayoutPanel.prototype.ag = function (e_) {
        var a = (e_.originalEvent.pointerType);
        if (a == "touch") {
            this.al(e_);
        }
        else {
            this.z(e_);
        }
    };
    DataGridCellLayoutPanel.prototype.ah = function (e_) {
        var a = (e_.originalEvent.pointerType);
        if (a == "touch") {
            this.am(e_);
        }
        else {
            this.aa(e_);
        }
    };
    DataGridCellLayoutPanel.prototype.ak = function (a) {
        this.ae(a, true);
    };
    DataGridCellLayoutPanel.prototype.ae = function (a, b) {
        if (this.e == null) {
            return;
        }
        var c = this.q.rootWrapper.getOffset();
        var d = this.e.e(a.pageX - c.left, a.pageY - c.top);
        if (d == null) {
            return;
        }
        if (d.r != null) {
            if (d.r.isCanvasBased && d.r.nativeCell != null) {
                d.r.nativeCell.onContactStarted(a, b);
            }
        }
    };
    DataGridCellLayoutPanel.prototype.al = function (a) {
        this.ad(a, true);
    };
    DataGridCellLayoutPanel.prototype.ad = function (a, b) {
        if (this.e == null) {
            return;
        }
        var c = this.q.rootWrapper.getOffset();
        var d = this.e.e(a.pageX - c.left, a.pageY - c.top);
        if (d == null) {
            return;
        }
        if (d.r != null) {
            if (d.r.isCanvasBased && d.r.nativeCell != null) {
                d.r.nativeCell.onContactMoved(a, b);
            }
        }
    };
    DataGridCellLayoutPanel.prototype.am = function (a) {
        this.ac(a, true);
    };
    DataGridCellLayoutPanel.prototype.ac = function (a, b) {
        if (this.e == null) {
            return;
        }
        var c = this.q.rootWrapper.getOffset();
        var d = this.e.e(a.pageX - c.left, a.pageY - c.top);
        if (d == null) {
            return;
        }
        if (d.r != null) {
            if (d.r.isCanvasBased && d.r.nativeCell != null) {
                d.r.nativeCell.onContactCompleted(a, b);
            }
        }
    };
    DataGridCellLayoutPanel.prototype.an = function (a, b, c, d, e, f, g) {
        if (g) {
            b = 0;
        }
        if (this.c == null) {
            this.c = new Array(d.bu.count);
            this.a = new Array(d.bu.count);
            this.d = new Array(d.bu.count);
            this.b = new Array(d.bu.count);
            for (var h = 0; h < d.bu.count; h++) {
                this.c[h] = null;
                this.a[h] = null;
                this.d[h] = -1;
                this.b[h] = -1;
            }
        }
        if (this.c[b] == null) {
            var i = this.q.createElement("canvas");
            this.a[b] = i;
            i.setRawStyleProperty("position", "absolute");
            i.setRawStyleProperty("z-index", e.toString());
            this.element.append(i);
            var j_1 = this.q.get2DCanvasContext(i);
            var k = ((function () {
                var $ret = new CanvasViewRenderer();
                $ret.h$d = j_1;
                return $ret;
            })());
            this.c[b] = new RenderingContext(k, j_1);
        }
        if (a.a != this.c[b]) {
            a.a = this.c[b];
            a.b = true;
            a.c = d.actualVisibleRegion.left;
            a.d = d.actualVisibleRegion.top;
            var l = d.actualVisibleRegion.width * this.p;
            var m = d.actualVisibleRegion.height * this.p;
            if (l != this.d[b] || m != this.b[b]) {
                this.a[b].setRawSize(d.actualVisibleRegion.width, d.actualVisibleRegion.height);
                this.a[b].setAttribute("width", l + "px");
                this.a[b].setAttribute("height", m + "px");
                this.d[b] = l;
                this.b[b] = m;
            }
            if (f) {
                this.a[b].setRawStyleProperty("z-index", e.toString());
            }
            a.a.k(0, 0, d.actualVisibleRegion.width, d.actualVisibleRegion.height);
            this.a[b].setRawPosition(a.c, a.d);
        }
    };
    DataGridCellLayoutPanel.prototype.ao = function (a) {
        var b = this.e.b8;
        var c = this.e.b3 + this.e.b0;
        var d = this.e.cf;
        var e = this.e.by;
        if (a == 2) {
            c = Math.min(this.e.cj, this.e.b6) - this.e.cg - this.e.b1;
            d = this.e.cg;
        }
        return new Rect(0, c, b, d, e);
    };
    DataGridCellLayoutPanel.prototype.t = function (a, b, c) {
        if (a != 0) {
            var d = this.ao(a);
            var e = d.x - b;
            var f = d.y - c;
            var g = e + d.width;
            var h = f + d.height;
            return "rect(" + f + "px," + g + "px," + h + "px," + e + "px)";
        }
        return "auto";
    };
    DataGridCellLayoutPanel.$t = markType(DataGridCellLayoutPanel, 'DataGridCellLayoutPanel', Base.$, [ICellRenderingEngine_$type]);
    return DataGridCellLayoutPanel;
}(Base));
export { DataGridCellLayoutPanel };
//# sourceMappingURL=DataGridCellLayoutPanel.js.map
